import { getProcessesPath } from '../Parser/bindings';

export function getDialogProcessPath(graphPath: string, processId: string) {
  return graphPath.endsWith(processId) ? graphPath : `${getProcessesPath(graphPath)}.${processId}`;
}
